import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authApi, LoginRequest } from "../../services/api";
import { UserResponse } from "types/responses.type";

interface AuthState {
  user: UserResponse | null;
  token: string | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: JSON.parse(localStorage.getItem("owlara_user") || "null"),
  token: localStorage.getItem("owlara_token"),
  isLoading: false,
  error: null,
};

export const login = createAsyncThunk(
  "auth/login",
  async (credentials: LoginRequest, { rejectWithValue }) => {
    try {
      const response = await authApi.login(credentials);
      if (!response.ok || !response.data) {
        return rejectWithValue(response.errorMessage || "Login failed");
      }
      return response.data;
    } catch (error) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async () => {
  authApi.logout();
});

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setUser: (state, action) => {
      state.user = action.payload;
      localStorage.setItem("owlara_user", JSON.stringify(action.payload));
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
        localStorage.setItem("owlara_token", action.payload.token);
        localStorage.setItem(
          "owlara_user",
          JSON.stringify(action.payload.user)
        );
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.token = null;
      });
  },
});

export const { clearError, setUser } = authSlice.actions;
export default authSlice.reducer;
